"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _jsxFileName = "/builds/schumacherweb/devbridge/ui-shared/549481182/shared/src/theme/icons/files/devices.svg.js",
    _mask,
    _g,
    _path,
    _path2,
    _path3,
    _path4,
    _path5,
    _path6,
    _path7,
    _path8,
    _path9,
    _path10,
    _path11,
    _path12,
    _path13,
    _path14,
    _path15,
    _path16,
    _path17,
    _path18,
    _path19,
    _path20,
    _path21,
    _path22,
    _path23,
    _path24,
    _path25,
    _path26,
    _path27,
    _path28,
    _path29,
    _path30,
    _path31,
    _path32,
    _path33,
    _path34,
    _path35,
    _path36,
    _path37,
    _path38,
    _mask2,
    _g2,
    _mask3,
    _g3,
    _mask4,
    _g4,
    _mask5,
    _g5,
    _mask6,
    _g6,
    _path39,
    _path40,
    _path41,
    _path42,
    _path43,
    _path44,
    _path45,
    _path46,
    _path47,
    _path48,
    _path49,
    _path50,
    _path51,
    _path52,
    _path53,
    _path54,
    _defs;

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function ReactComponent(props) {
  return React.createElement("svg", (0, _extends2["default"])({
    width: 496,
    height: 496,
    viewBox: "0 0 496 496",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 5
    },
    __self: this
  }), _mask || (_mask = React.createElement("mask", {
    id: "prefix__a",
    x: 0,
    y: 0,
    width: 495,
    height: 495,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 13
    },
    __self: this
  }, React.createElement("path", {
    d: "M247.429 494.857c136.651 0 247.428-110.777 247.428-247.428S384.08 0 247.429 0 0 110.778 0 247.429s110.778 247.428 247.429 247.428z",
    fill: "#fff",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 14
    },
    __self: this
  }))), _g || (_g = React.createElement("g", {
    mask: "url(#prefix__a)",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 19
    },
    __self: this
  }, React.createElement("path", {
    d: "M247.429 494.857c136.651 0 247.428-110.777 247.428-247.428S384.08 0 247.429 0 0 110.778 0 247.429s110.778 247.428 247.429 247.428z",
    fill: "url(#prefix__paint0_linear_4515_27101)",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 20
    },
    __self: this
  }))), _path || (_path = React.createElement("path", {
    d: "M73.232 112.042l44.299-.985v224.421H61.693c.872-137.229.872-208.276 0-213.141-.873-4.866 2.973-8.298 11.539-10.295z",
    fill: "#040636",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 25
    },
    __self: this
  })), _path2 || (_path2 = React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.188 114.402c-9.642 0-17.458 7.817-17.458 17.459V329.62h336.534V131.861c0-9.642-7.817-17.459-17.459-17.459H82.188zm-29.174 17.459c0-16.113 13.062-29.175 29.174-29.175h301.617c16.113 0 29.175 13.062 29.175 29.175v209.475H53.014V131.861z",
    fill: "#474C55",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 29
    },
    __self: this
  })), _path3 || (_path3 = React.createElement("path", {
    d: "M15.622 331.981h432.88c0 5.685-4.609 10.295-10.295 10.295H25.917c-5.686 0-10.295-4.61-10.295-10.295z",
    fill: "#474C55",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 35
    },
    __self: this
  })), _path4 || (_path4 = React.createElement("path", {
    d: "M117.531 149.478H64.797v14.039h52.734v-14.039z",
    fill: "#03042B",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 39
    },
    __self: this
  })), _path5 || (_path5 = React.createElement("path", {
    d: "M73.56 160.288a3.79 3.79 0 10-.002-7.58 3.79 3.79 0 00.002 7.58z",
    fill: "#2369CB",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 40
    },
    __self: this
  })), _path6 || (_path6 = React.createElement("path", {
    d: "M73.56 174.278a3.79 3.79 0 10-.002-7.58 3.79 3.79 0 00.002 7.58zM73.56 188.268a3.79 3.79 0 10-.002-7.58 3.79 3.79 0 00.002 7.58zM73.56 201.092a3.79 3.79 0 10-.002-7.58 3.79 3.79 0 00.002 7.58z",
    fill: "#718093",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 41
    },
    __self: this
  })), _path7 || (_path7 = React.createElement("path", {
    d: "M101.193 154.111H82.618a2.652 2.652 0 100 5.304h18.575a2.652 2.652 0 100-5.304z",
    fill: "#fff",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 45
    },
    __self: this
  })), _path8 || (_path8 = React.createElement("path", {
    d: "M100.855 167.884h-18.94a2.652 2.652 0 000 5.304h18.94a2.652 2.652 0 100-5.304zM100.855 181.923h-18.94a2.652 2.652 0 100 5.304h18.94a2.652 2.652 0 000-5.304zM100.855 195.026h-18.94a2.652 2.652 0 100 5.303h18.94a2.651 2.651 0 100-5.303z",
    fill: "#718093",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 49
    },
    __self: this
  })), _path9 || (_path9 = React.createElement("path", {
    d: "M402.458 133.568H117.531v41.969h284.927v-41.969z",
    fill: "#fff",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 53
    },
    __self: this
  })), _path10 || (_path10 = React.createElement("path", {
    d: "M402.458 175.537H117.531v156.221h284.927V175.537z",
    fill: "#F5F6FA",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 54
    },
    __self: this
  })), _path11 || (_path11 = React.createElement("path", {
    d: "M117.531 114.356h267.097c9.034 0 16.569 6.937 17.35 15.975l.48 5.551H117.531v-21.526z",
    fill: "#000",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 55
    },
    __self: this
  })), _path12 || (_path12 = React.createElement("path", {
    d: "M117.531 114.356h267.097c9.034 0 16.569 6.937 17.35 15.975l.48 5.551H117.531v-21.526z",
    fill: "#fff",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 59
    },
    __self: this
  })), _path13 || (_path13 = React.createElement("path", {
    d: "M147.199 122.337h-16.824a2.34 2.34 0 100 4.679h16.824a2.34 2.34 0 100-4.679z",
    fill: "#353B48",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 63
    },
    __self: this
  })), _path14 || (_path14 = React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M136.22 154.666a6.043 6.043 0 100 12.086h65.432a6.043 6.043 0 000-12.086H136.22zm-7.996 6.043a7.996 7.996 0 017.996-7.996h65.432a7.996 7.996 0 010 15.992H136.22a7.996 7.996 0 01-7.996-7.996z",
    fill: "#C7D2E0",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 67
    },
    __self: this
  })), _path15 || (_path15 = React.createElement("path", {
    d: "M160.377 143.362h-29.795a2.59 2.59 0 000 5.18h29.795a2.59 2.59 0 000-5.18z",
    fill: "#C7D2E0",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 73
    },
    __self: this
  })), _path16 || (_path16 = React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M228.706 154.666a6.044 6.044 0 000 12.086h65.432a6.044 6.044 0 000-12.086h-65.432zm-7.996 6.043a7.996 7.996 0 017.996-7.996h65.432a7.996 7.996 0 010 15.992h-65.432a7.996 7.996 0 01-7.996-7.996z",
    fill: "#C7D2E0",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 77
    },
    __self: this
  })), _path17 || (_path17 = React.createElement("path", {
    d: "M248.08 143.362h-21.514a2.59 2.59 0 100 5.18h21.514a2.59 2.59 0 100-5.18z",
    fill: "#C7D2E0",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 83
    },
    __self: this
  })), _path18 || (_path18 = React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M320.026 154.666a6.044 6.044 0 000 12.086h65.432a6.044 6.044 0 000-12.086h-65.432zm-7.996 6.043a7.996 7.996 0 017.996-7.996h65.432a7.995 7.995 0 017.995 7.996 7.995 7.995 0 01-7.995 7.996h-65.432a7.996 7.996 0 01-7.996-7.996z",
    fill: "#C7D2E0",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 87
    },
    __self: this
  })), _path19 || (_path19 = React.createElement("path", {
    d: "M365.167 143.362h-47.282a2.59 2.59 0 000 5.18h47.282a2.59 2.59 0 100-5.18z",
    fill: "#C7D2E0",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 93
    },
    __self: this
  })), _path20 || (_path20 = React.createElement("path", {
    d: "M152.364 186.914H130.85a2.59 2.59 0 000 5.181h21.514a2.59 2.59 0 100-5.181z",
    fill: "#2369CB",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 97
    },
    __self: this
  })), _path21 || (_path21 = React.createElement("path", {
    d: "M385.711 186.914h-21.514a2.59 2.59 0 000 5.181h21.514a2.59 2.59 0 100-5.181zM267.557 186.914h-47.282a2.59 2.59 0 000 5.181h47.282a2.59 2.59 0 100-5.181zM349.086 186.914h-64.769a2.59 2.59 0 000 5.181h64.769a2.59 2.59 0 000-5.181z",
    fill: "#C7D2E0",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 101
    },
    __self: this
  })), _path22 || (_path22 = React.createElement("path", {
    d: "M390.57 199.962H128.26v1.953h262.31v-1.953z",
    fill: "#C7D2E0",
    fillOpacity: 0.36,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 105
    },
    __self: this
  })), _path23 || (_path23 = React.createElement("path", {
    d: "M153.527 211.865h-21.514a2.59 2.59 0 100 5.18h21.514a2.59 2.59 0 100-5.18z",
    fill: "#2369CB",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 106
    },
    __self: this
  })), _path24 || (_path24 = React.createElement("path", {
    d: "M386.875 211.865H365.36a2.59 2.59 0 100 5.18h21.515a2.59 2.59 0 000-5.18zM268.72 211.865h-47.282a2.59 2.59 0 100 5.18h47.282a2.59 2.59 0 000-5.18zM350.249 211.865H285.48a2.59 2.59 0 100 5.18h64.769a2.59 2.59 0 000-5.18z",
    fill: "#C7D2E0",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 110
    },
    __self: this
  })), _path25 || (_path25 = React.createElement("path", {
    d: "M391.733 224.912h-262.31v1.953h262.31v-1.953z",
    fill: "#C7D2E0",
    fillOpacity: 0.36,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 114
    },
    __self: this
  })), _path26 || (_path26 = React.createElement("path", {
    d: "M153.527 238.398h-21.514a2.59 2.59 0 100 5.18h21.514a2.59 2.59 0 100-5.18z",
    fill: "#2369CB",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 115
    },
    __self: this
  })), _path27 || (_path27 = React.createElement("path", {
    d: "M386.875 238.398H365.36a2.59 2.59 0 100 5.18h21.515a2.59 2.59 0 000-5.18zM268.72 238.398h-47.282a2.59 2.59 0 100 5.18h47.282a2.59 2.59 0 000-5.18zM350.249 238.398H285.48a2.59 2.59 0 100 5.18h64.769a2.59 2.59 0 000-5.18z",
    fill: "#C7D2E0",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 119
    },
    __self: this
  })), _path28 || (_path28 = React.createElement("path", {
    d: "M391.733 251.445h-262.31v1.953h262.31v-1.953z",
    fill: "#C7D2E0",
    fillOpacity: 0.36,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 123
    },
    __self: this
  })), _path29 || (_path29 = React.createElement("path", {
    d: "M153.527 264.93h-21.514a2.59 2.59 0 000 5.181h21.514a2.59 2.59 0 100-5.181z",
    fill: "#2369CB",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 124
    },
    __self: this
  })), _path30 || (_path30 = React.createElement("path", {
    d: "M386.875 264.93H365.36a2.59 2.59 0 000 5.181h21.515a2.59 2.59 0 000-5.181zM268.72 264.93h-47.282a2.59 2.59 0 000 5.181h47.282a2.59 2.59 0 000-5.181zM350.249 264.93H285.48a2.59 2.59 0 000 5.181h64.769a2.59 2.59 0 000-5.181z",
    fill: "#C7D2E0",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 128
    },
    __self: this
  })), _path31 || (_path31 = React.createElement("path", {
    d: "M391.733 277.978h-262.31v1.953h262.31v-1.953z",
    fill: "#C7D2E0",
    fillOpacity: 0.36,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 132
    },
    __self: this
  })), _path32 || (_path32 = React.createElement("path", {
    d: "M153.527 285.702h-21.514a2.59 2.59 0 100 5.18h21.514a2.59 2.59 0 100-5.18z",
    fill: "#2369CB",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 133
    },
    __self: this
  })), _path33 || (_path33 = React.createElement("path", {
    d: "M386.875 285.702H365.36a2.59 2.59 0 100 5.18h21.515a2.59 2.59 0 000-5.18zM268.72 285.702h-47.282a2.59 2.59 0 100 5.18h47.282a2.59 2.59 0 000-5.18zM350.249 285.702H285.48a2.59 2.59 0 100 5.18h64.769a2.59 2.59 0 000-5.18z",
    fill: "#C7D2E0",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 137
    },
    __self: this
  })), _path34 || (_path34 = React.createElement("path", {
    d: "M391.733 298.749h-262.31v1.953h262.31v-1.953z",
    fill: "#C7D2E0",
    fillOpacity: 0.36,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 141
    },
    __self: this
  })), _path35 || (_path35 = React.createElement("path", {
    d: "M153.527 311.209h-21.514a2.59 2.59 0 000 5.181h21.514a2.59 2.59 0 100-5.181z",
    fill: "#2369CB",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 142
    },
    __self: this
  })), _path36 || (_path36 = React.createElement("path", {
    d: "M386.875 311.209H365.36a2.59 2.59 0 000 5.181h21.515a2.59 2.59 0 000-5.181zM268.72 311.209h-47.282a2.59 2.59 0 000 5.181h47.282a2.59 2.59 0 000-5.181zM350.249 311.209H285.48a2.59 2.59 0 000 5.181h64.769a2.59 2.59 0 000-5.181z",
    fill: "#C7D2E0",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 146
    },
    __self: this
  })), _path37 || (_path37 = React.createElement("path", {
    d: "M391.733 324.257h-262.31v1.953h262.31v-1.953z",
    fill: "#C7D2E0",
    fillOpacity: 0.36,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 150
    },
    __self: this
  })), _path38 || (_path38 = React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M393.494 142.551c-5.947 0-10.754 4.804-10.754 10.714v177.892c0 5.911 4.807 10.714 10.754 10.714h71.905c5.946 0 10.753-4.803 10.753-10.714V153.265c0-5.91-4.807-10.714-10.753-10.714h-71.905zm-16.612 10.714c0-9.163 7.447-16.572 16.612-16.572h71.905c9.165 0 16.612 7.409 16.612 16.572v177.892c0 9.163-7.447 16.573-16.612 16.573h-71.905c-9.165 0-16.612-7.41-16.612-16.573V153.265z",
    fill: "#474C55",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 151
    },
    __self: this
  })), _mask2 || (_mask2 = React.createElement("mask", {
    id: "prefix__b",
    x: 381,
    y: 141,
    width: 96,
    height: 202,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 157
    },
    __self: this
  }, React.createElement("path", {
    d: "M476.708 331.227c0 6.495-5.282 11.76-11.8 11.76h-71.905c-6.517 0-11.8-5.265-11.8-11.76V153.335c0-6.496 5.283-11.761 11.8-11.761h71.905c6.518 0 11.8 5.265 11.8 11.761v177.892z",
    fill: "#fff",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 158
    },
    __self: this
  }))), _g2 || (_g2 = React.createElement("g", {
    mask: "url(#prefix__b)",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 163
    },
    __self: this
  }, React.createElement("path", {
    d: "M387.975 141.514h82.071a8.786 8.786 0 018.786 8.786v19.425h-99.643V150.3a8.786 8.786 0 018.786-8.786z",
    fill: "#F5F6FA",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 164
    },
    __self: this
  }))), _mask3 || (_mask3 = React.createElement("mask", {
    id: "prefix__c",
    x: 381,
    y: 141,
    width: 96,
    height: 202,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 169
    },
    __self: this
  }, React.createElement("path", {
    d: "M476.708 331.227c0 6.495-5.282 11.76-11.8 11.76h-71.905c-6.517 0-11.8-5.265-11.8-11.76V153.335c0-6.496 5.283-11.761 11.8-11.761h71.905c6.518 0 11.8 5.265 11.8 11.761v177.892z",
    fill: "#fff",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 170
    },
    __self: this
  }))), _g3 || (_g3 = React.createElement("g", {
    mask: "url(#prefix__c)",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 175
    },
    __self: this
  }, React.createElement("path", {
    d: "M478.832 315.817h-99.643v28.21h99.643v-28.21z",
    fill: "#F5F6FA",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 176
    },
    __self: this
  }))), _mask4 || (_mask4 = React.createElement("mask", {
    id: "prefix__d",
    x: 381,
    y: 141,
    width: 96,
    height: 202,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 178
    },
    __self: this
  }, React.createElement("path", {
    d: "M476.708 331.227c0 6.495-5.282 11.76-11.8 11.76h-71.905c-6.517 0-11.8-5.265-11.8-11.76V153.335c0-6.496 5.283-11.761 11.8-11.761h71.905c6.518 0 11.8 5.265 11.8 11.761v177.892z",
    fill: "#fff",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 179
    },
    __self: this
  }))), _g4 || (_g4 = React.createElement("g", {
    mask: "url(#prefix__d)",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 184
    },
    __self: this
  }, React.createElement("path", {
    d: "M476.708 331.227c0 6.495-5.282 11.76-11.8 11.76h-71.905c-6.517 0-11.8-5.265-11.8-11.76V153.335c0-6.496 5.283-11.761 11.8-11.761h71.905c6.518 0 11.8 5.265 11.8 11.761v177.892z",
    fill: "#fff",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 185
    },
    __self: this
  }))), _mask5 || (_mask5 = React.createElement("mask", {
    id: "prefix__e",
    x: 381,
    y: 141,
    width: 96,
    height: 27,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 190
    },
    __self: this
  }, React.createElement("path", {
    d: "M381.203 153.335c3.522-7.841 7.456-11.761 11.801-11.761h71.905c6.517 0 11.8 5.265 11.8 11.761v14.37h-95.561l.055-14.37z",
    fill: "#fff",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 191
    },
    __self: this
  }))), _g5 || (_g5 = React.createElement("g", {
    mask: "url(#prefix__e)",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 196
    },
    __self: this
  }, React.createElement("path", {
    d: "M381.203 153.335c3.522-7.841 7.456-11.761 11.801-11.761h71.905c6.517 0 11.8 5.265 11.8 11.761v14.37h-95.561l.055-14.37z",
    fill: "#000",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 197
    },
    __self: this
  }), React.createElement("path", {
    d: "M381.203 153.335c3.522-7.841 7.456-11.761 11.801-11.761h71.905c6.517 0 11.8 5.265 11.8 11.761v14.37h-95.561l.055-14.37z",
    fill: "#fff",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 201
    },
    __self: this
  }))), _mask6 || (_mask6 = React.createElement("mask", {
    id: "prefix__f",
    x: 381,
    y: 319,
    width: 96,
    height: 24,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 206
    },
    __self: this
  }, React.createElement("path", {
    d: "M381.203 329.968c1.673-7.104 5.606-10.656 11.801-10.656h71.905c6.517 0 11.8 4.77 11.8 10.656v13.019h-95.561l.055-13.019z",
    fill: "#fff",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 207
    },
    __self: this
  }))), _g6 || (_g6 = React.createElement("g", {
    mask: "url(#prefix__f)",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 212
    },
    __self: this
  }, React.createElement("rect", {
    x: 381.198,
    y: 319.373,
    width: 95.509,
    height: 23.687,
    rx: 11.843,
    fill: "#040636",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 213
    },
    __self: this
  }), React.createElement("path", {
    d: "M398.817 336.975a6.546 6.546 0 006.542-6.549 6.545 6.545 0 00-6.542-6.549 6.546 6.546 0 00-6.543 6.549 6.546 6.546 0 006.543 6.549z",
    fill: "#2369CB",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 214
    },
    __self: this
  }), React.createElement("path", {
    d: "M419.281 336.975a6.546 6.546 0 006.543-6.549 6.546 6.546 0 00-6.543-6.549 6.545 6.545 0 00-6.542 6.549 6.546 6.546 0 006.542 6.549zM439.747 336.975a6.546 6.546 0 006.542-6.549 6.545 6.545 0 00-6.542-6.549 6.545 6.545 0 00-6.542 6.549 6.546 6.546 0 006.542 6.549zM460.212 336.975a6.546 6.546 0 006.542-6.549 6.545 6.545 0 00-6.542-6.549 6.545 6.545 0 00-6.542 6.549 6.546 6.546 0 006.542 6.549z",
    fill: "#C7D2E0",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 218
    },
    __self: this
  }))), _path39 || (_path39 = React.createElement("path", {
    d: "M435.047 153.605h-18.111a2.52 2.52 0 000 5.037h18.111a2.518 2.518 0 100-5.037z",
    fill: "#353B48",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 223
    },
    __self: this
  })), _path40 || (_path40 = React.createElement("path", {
    d: "M464.801 153.605h-1.127a1.952 1.952 0 00-1.952 1.953v1.132c0 1.078.874 1.952 1.952 1.952h1.127a1.952 1.952 0 001.953-1.952v-1.132a1.953 1.953 0 00-1.953-1.953z",
    fill: "#718093",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 227
    },
    __self: this
  })), _path41 || (_path41 = React.createElement("path", {
    d: "M476.764 187.907h-95.616v42.452h95.616v-42.452z",
    fill: "#F5F6FA",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 231
    },
    __self: this
  })), _path42 || (_path42 = React.createElement("path", {
    d: "M429.011 202.894c3.076 0 5.57-2.534 5.57-5.659s-2.494-5.658-5.57-5.658-5.57 2.533-5.57 5.658c0 3.125 2.494 5.659 5.57 5.659z",
    fill: "#9C88FF",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 232
    },
    __self: this
  })), _path43 || (_path43 = React.createElement("path", {
    d: "M442.496 208.874h-27.079a2.789 2.789 0 100 5.576h27.079a2.788 2.788 0 100-5.576z",
    fill: "#353B48",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 236
    },
    __self: this
  })), _path44 || (_path44 = React.createElement("path", {
    d: "M434.386 217.854h-10.751a2.788 2.788 0 100 5.576h10.751a2.788 2.788 0 100-5.576zM406.78 175.938h-18.915a2.79 2.79 0 000 5.577h18.915a2.79 2.79 0 000-5.577zM440.071 175.938h-22.997a2.789 2.789 0 000 5.577h22.997a2.79 2.79 0 000-5.577z",
    fill: "#C7D2E0",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 240
    },
    __self: this
  })), _path45 || (_path45 = React.createElement("path", {
    d: "M470.686 175.938h-20.14a2.789 2.789 0 000 5.577h20.14a2.788 2.788 0 000-5.577z",
    fill: "#2369CB",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 244
    },
    __self: this
  })), _path46 || (_path46 = React.createElement("path", {
    d: "M390.647 251.411c3.076 0 5.57-2.533 5.57-5.658 0-3.126-2.494-5.659-5.57-5.659s-5.57 2.533-5.57 5.659c0 3.125 2.494 5.658 5.57 5.658z",
    fill: "#1C3D6B",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 248
    },
    __self: this
  })), _path47 || (_path47 = React.createElement("path", {
    d: "M429.475 240.094h-27.079a2.789 2.789 0 100 5.577h27.079a2.789 2.789 0 000-5.577z",
    fill: "#2369CB",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 252
    },
    __self: this
  })), _path48 || (_path48 = React.createElement("path", {
    d: "M466.753 248.131h-64.357a2.789 2.789 0 100 5.576h64.357a2.788 2.788 0 100-5.576zM441.72 256.168h-39.324a2.789 2.789 0 100 5.576h39.324a2.789 2.789 0 100-5.576z",
    fill: "#C7D2E0",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 256
    },
    __self: this
  })), _path49 || (_path49 = React.createElement("path", {
    d: "M390.647 282.858c3.076 0 5.57-2.533 5.57-5.658 0-3.125-2.494-5.659-5.57-5.659s-5.57 2.534-5.57 5.659 2.494 5.658 5.57 5.658z",
    fill: "#1C3D6B",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 260
    },
    __self: this
  })), _path50 || (_path50 = React.createElement("path", {
    d: "M429.475 271.541h-27.079a2.79 2.79 0 000 5.577h27.079a2.788 2.788 0 000-5.577z",
    fill: "#2369CB",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 264
    },
    __self: this
  })), _path51 || (_path51 = React.createElement("path", {
    d: "M466.753 279.578h-64.357a2.789 2.789 0 100 5.577h64.357a2.789 2.789 0 000-5.577zM441.72 287.615h-39.324a2.789 2.789 0 100 5.576h39.324a2.789 2.789 0 100-5.576z",
    fill: "#C7D2E0",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 268
    },
    __self: this
  })), _path52 || (_path52 = React.createElement("path", {
    d: "M390.647 314.306c3.076 0 5.57-2.534 5.57-5.659s-2.494-5.659-5.57-5.659-5.57 2.534-5.57 5.659 2.494 5.659 5.57 5.659z",
    fill: "#1C3D6B",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 272
    },
    __self: this
  })), _path53 || (_path53 = React.createElement("path", {
    d: "M429.475 302.988h-27.079a2.79 2.79 0 000 5.577h27.079a2.788 2.788 0 100-5.577z",
    fill: "#2369CB",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 276
    },
    __self: this
  })), _path54 || (_path54 = React.createElement("path", {
    d: "M466.753 311.025h-64.357a2.79 2.79 0 000 5.577h64.357a2.789 2.789 0 000-5.577z",
    fill: "#C7D2E0",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 280
    },
    __self: this
  })), _defs || (_defs = React.createElement("defs", {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 284
    },
    __self: this
  }, React.createElement("linearGradient", {
    id: "prefix__paint0_linear_4515_27101",
    x1: 247.429,
    y1: 177.231,
    x2: 247.429,
    y2: 494.857,
    gradientUnits: "userSpaceOnUse",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 285
    },
    __self: this
  }, React.createElement("stop", {
    stopColor: "#EBF1F8",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 293
    },
    __self: this
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F6FA",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 294
    },
    __self: this
  })))));
}

var _default = ReactComponent;
exports["default"] = _default;